/**
 * 登录 token 的本地存储（`specs/15` §2 · `ADR-018` D1）。
 *
 * 刻意**不放进 zustand**：`client.ts` 要在**每个请求**上读它，而 store ↔ api
 * 互相 import 会成环。这里是一层极薄的 localStorage 封装，读写各一处。
 */
const KEY = "otherwise.auth.token";

export function readToken(): string | null {
  try {
    return window.localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function writeToken(token: string): void {
  try {
    window.localStorage.setItem(KEY, token);
  } catch {
    // 隐私模式下不可写：登录态只存活于本次会话，不影响请求头注入。
  }
}

export function clearToken(): void {
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    // 同上：清不掉也不该抛。
  }
}
